// This file is AUTOGENERATED, do not edit it manually!!!

export const customFields = {
    text_delete: 'Alanı sil',
    text_edit: 'Form düzeni Düzenle',
    text_filter: 'Özel Alanlar için',
    text_include_in_unportfolioed_projects: 'Include in unportfolioed ones',
};
